import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit, inject, OnDestroy } from '@angular/core';
import { CompanyModel } from '../../../models/company.model';
import { CompaniesService } from '../../../services/company.service';
import { RolesService } from '../../../services/roles.service';
import { ToastService } from '../../../services/toast.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { GlobalStoreService } from '../../../services/global-store.service';
import { DrawerComponent } from '../../layout/kt/components/_DrawerComponent';
import { UserManagementService } from '../../../services/user-managament.service';
import { SharedImports } from '../../../shared-imports';

@Component({
	selector: 'app-invite-user-drawer',
	templateUrl: './invite-user-drawer.component.html',
	standalone: true,
	imports: [SharedImports],
})
export class InviteUserDrawerComponent implements OnInit, AfterViewInit, OnDestroy {
	roleActive: boolean = false;
	activeCompany: CompanyModel;

	private _subscriptions: Subscription[] = [];
	private mutationObserver: MutationObserver | null = null;
	roles$ = new BehaviorSubject<CompanyModel[] | any>(null);
	userRoler$ = new BehaviorSubject<any>(null);

	userEmailError = false;
	roleIsCreatedOrUpdated = true;
	userEmail: string = '';
	messageContent: string = '';

	private rolesService = inject(RolesService);
	private companiesService = inject(CompaniesService);
	private toastService = inject(ToastService);
	private userManagementService = inject(UserManagementService);

	constructor() {
		this._subscriptions.push(
			this.companiesService.company$.subscribe({
				next: (res) => {
					if (res && res?.uuid) {
						this.activeCompany = res;
					}
				},
				error: (err) => {},
				complete: () => {},
			})
		);
	}

	onRoleChange(event: any) {
		this.userRoler$.next(event);
	}

	ngOnInit(): void {}

	loadRoles() {
		if (this.activeCompany) {
			this.rolesService.getManyCompanyRoles(this.activeCompany.uuid, {}).subscribe({
				next: (res: any) => {
					this.roles$.next(res.data.length > 0 ? res.data : null);
				},
				error: (err) => {},
			});
		}
	}

	validateRoleName() {
		this.userEmailError = !this.userEmail || this.userEmail.trim() === '';
	}

	inviteUser() {
		if (this.userEmailError) {
			return;
		}
		const body: any = {
			email: this.userEmail,
			role: this.userRoler$.value?.uuid,
		};

		this.userManagementService.inviteUserToCompany(this.activeCompany.uuid, body).subscribe({
			next: (res) => {
				this.toastService.success('invitation_sent_successfully', 'Success');
				this.onClose();
			},
			error: (err) => {
				this.toastService.error('error_sending_invitation', 'Error');
			},
		});
	}

	ngAfterViewInit(): void {
		if (this.mutationObserver) {
			this.mutationObserver.disconnect();
			this.mutationObserver = null;
		}

		this.mutationObserver = new MutationObserver(() => {
			const drawer = DrawerComponent.getInstance('kt_invite_user');
			if (drawer) {
				drawer.on('kt.drawer.show', () => {
					this.loadRoles();
				});

				drawer.on('kt.drawer.hide', () => {
					this.ngOnDestroy();
				});
				this.mutationObserver?.disconnect();
				this.mutationObserver = null;
			}
		});

		this.mutationObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	ngOnDestroy(): void {
		this.userEmail = '';
		this.messageContent = '';
		this.userEmailError = false;

		if (this.mutationObserver) {
			this.mutationObserver.disconnect();
			this.mutationObserver = null;
		}
	}

	onClose() {
		const drawer = DrawerComponent.getInstance('kt_create_company_role');
		if (drawer) {
			drawer.hide();
		}
		this.ngOnDestroy();
	}
}
